import React from 'react';
import { Box, Text, Image, SimpleGrid } from '@chakra-ui/react';

const Gallery = () => {
  // Gallery items with actual images and descriptions
  const galleryItems = [
    {
      title: 'Cthulhu',
      description: 'The statuette of Cthulhu, created by the description from the story "The Call of Cthulhu." Plasticine, acrylic, superimposed texture of malachite.',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/7/7d/Cthulhu_statue_green.jpg',
    },
    {
      title: 'Nyarlathotep',
      description: 'Krita drawing - Nyarlathotep - The black man, The crawling Chaos, the Stalker among the Stars, the Black Pharaoh. From H.P. Lovecraft\'s strange universes. This piece is made in collaboration between the Scandinavian artist Katharsisdrill and the fractal artist Nyarlathotep.',
      imageUrl: 'https://upload.wikimedia.org/wikipedia/commons/0/09/Nyarlathotep_the_Black_Pharaoh_by_Katharsisdrill.jpg',
    },
    // More gallery items to be added here
  ];

  return (
    <Box>
      <Text fontSize="2xl" mb={4}>Cosmic Horrors Gallery</Text>
      <SimpleGrid columns={{ sm: 1, md: 2, lg: 3 }} spacing={10}>
        {galleryItems.map((item, index) => (
          <Box key={index} textAlign="center">
            <Image src={item.imageUrl} alt={item.title} boxSize="200px" objectFit="cover" />
            <Text fontWeight="bold" mt={2}>{item.title}</Text>
            <Text fontSize="sm">{item.description}</Text>
          </Box>
        ))}
      </SimpleGrid>
    </Box>
  );
};

export default Gallery;
